<template>
  <div class="member-sign">
    <div class="block-wrap content">
      <Breadcrumbs :routes="breadRoutes" />
      <div class="approval-query-wrap">
        <ApprovalProgressQuery :mem-type="memberCategary == 'group' ? 'org' : 'personal'" />
      </div>
      <div class="content-box" v-if="activeStep === 1">
        <div class="content-title" v-if="memberCategary == 'person'">浙江省风景园林学会个人会员</div>
        <div class="content-title" v-if="memberCategary == 'group'">浙江省风景园林学会团体会员入会须知</div>
        <div class="content-main">
          <div class="content-main-header">会员类型</div>
          <Table :columns="columns" :rows-data="groupData"  v-if="memberCategary == 'group'"/>
          <Table :columns="columns" :rows-data="personalData"  v-if="memberCategary == 'person'"/>          
        </div>
        <div class="content-main" v-if="memberCategary == 'person'">
          <div class="content-main-header">浙江省风景园林学会个人会员入会须知</div>
          <div class="list-wrap">
            <div class="list-item">1、拥护本会章程；</div>
            <div class="list-item">2、有加入本会的意愿；</div>
            <div class="list-item">3、在本会的业务领域内具有一定的影响。</div>
            <div class="list-item list-item-subtitle">个人入会还需具备下列条件之一：</div>
            <div class="list-item">（1）取得工程师以上及相应的职称或硕士以上学位的风景园林科技工作者；</div>
            <div class="list-item">（2）高等院校本科毕业，从事风景园林工作三年以上；大专毕业，从事风景园林工作四年以上；中专毕业，从事风景园林工作五年以上的风景园林科技工作者；</div>
            <div class="list-item">（3）技师或风景园林建设事业有突出贡献的风景园林工作者；</div>
            <div class="list-item">（4）热心并积极支持本会工作，有经验、有成绩的风景园林领导干部。</div>
          </div>
        </div>
        <div class="content-main" v-if="memberCategary == 'group'">
          <div class="content-main-header">浙江省风景园林学会团体会员入会须知</div>
          <div class="list-wrap">
            <div class="list-item">一、遵守本会章程，执行本会的决议</div>
            <div class="list-item">二、维护本会合法权益</div>
            <div class="list-item">三、向本会反映情况，提供有关资料</div>
            <div class="list-item">四、依照本会章程按时缴纳会费</div>
            <div class="list-item">五、学会章程规定的其他义务</div>
          </div>
        </div>
        <div class="content-main" v-if="memberCategary == 'group'">
          <div class="download-wrap">
            <div class="download-item">
              <img class="download-file-icon" src="../../assets/images/icon-file.png" alt="">
              <div class="download-title">团体会员申请（登记）表</div>
              <a class="download-op" target="_blank" href="http://47.97.86.254:8667/tmp/6c8d1bb41a4b4e15a8624c642b1481de.doc">下载</a>
            </div>
          </div>
        </div>
        <div class="card-more" @click="changeStep(2)">下一步</div>
      </div>
      <div class="content-box flex" ref="wrap" v-if="activeStep === 2">
        <div class="form-content">
          <div class="content-title" v-if="memberCategary == 'group'">注册团体会员</div>
          <div class="content-title" v-if="memberCategary == 'person'">注册个人会员</div>
          <div class="content-main" >
            <div class="content-main-header">账户信息<div class="help-tip-c">请填写账户信息，该手机号码将对应生成为学会网站的登录账号</div></div>
            <FormItem :field="form.phone" :form="form"></FormItem>
            <FormItem :field="form.adminName" :form="form" v-if="memberCategary == 'group'"></FormItem>            
            <FormItem :field="form.email" :form="form"></FormItem>
            <!--<FormItem :field="form.password" :form="form"></FormItem>
            <FormItem :field="form.repassword" :form="form"></FormItem>-->
          </div>
          <template v-if="memberCategary == 'group'">
            <div class="content-main">
              <div class="content-main-header" >基本信息<div class="help-tip-c">请填写企业基本信息</div></div>
              <!--<FormItem :field="form.memberType" :form="form"></FormItem>
              <FormItem :field="form.expressTime" :form="form"></FormItem>-->
              <FormItem :field="form.orgName" :form="form"></FormItem>
              <FormItem :field="form.orgTypeDicKey" :form="form"></FormItem>
              <FormItem :field="form.orgCategaryDicKey" :form="form"></FormItem>
              <FormItem :field="form.fixedTelephone" :form="form"></FormItem>
              <FormItem :field="form.locationProvince" :form="form"></FormItem>
              <FormItem :field="form.postalAddress" :form="form"></FormItem>
              <FormItem :field="form.postalCode" :form="form"></FormItem>
              <FormItem :field="form.companyProfile" :form="form"></FormItem>
            </div>
            <!--<div class="content-main">
              <div class="content-main-header">联系人信息</div>
              <FormItem :field="form.xm" :form="form"></FormItem>
              <FormItem :field="form.xb" :form="form"></FormItem>
              <FormItem :field="form.zw" :form="form"></FormItem>
              <FormItem :field="form.gddh" :form="form"></FormItem>
              <FormItem :field="form.sj" :form="form"></FormItem>
              <FormItem :field="form.dzyx" :form="form"></FormItem>            
            </div>-->
            <div class="content-main">
              <div class="content-main-header">注册信息<div class="help-tip-c">请填写企业注册信息</div></div>
              <FormItem :field="form.registrationTime" :form="form"></FormItem>
              <FormItem :field="form.registeredCapital" :form="form"></FormItem>
              <FormItem :field="form.legalRepresentative" :form="form"></FormItem>
              <FormItem :field="form.socialUnifiedCreditCode" :form="form"></FormItem>
              <FormItem :field="form.scopeOfBusiness" :form="form"></FormItem>
            </div>
            <div class="content-main">
              <div class="content-main-header">上传申报表<div class="help-tip-c">请上传已盖章的团体会员申报表扫描件</div></div>
              <div class="form-item upload-item">
                <div class="upload-wrap">
                  <div class="upload-add" :class="loading ? 'loading' : ''" >
                    上传申报表
                    <input v-if="!loading" type="file"  @change="onFileChange">
                  </div>
                  <div class="error-tip" v-if="orgAttachError">{{ orgAttachError }}</div>
                  <div class="upload-file-wrap">
                    <div class="upload-file"
                          v-for="(item, index) in currentFileList"
                          :key="index">                     
                      <span>{{item.name}}</span>
                      <i class="upload-file-delete" @click="deleteFile(index)"></i>
                    </div>
                  </div> 
                </div>
              </div>
            </div>
          </template>

          <template v-if="memberCategary == 'person'">
            <div class="content-main" >
              <div class="content-main-header">基本信息</div>
              <FormItem :field="form.realName" :form="form"></FormItem>
              <FormItem :field="form.enName" :form="form"></FormItem>
              <FormItem :field="form.sex" :form="form"></FormItem>
              <FormItem :field="form.nation" :form="form"></FormItem>
              <FormItem :field="form.politicalOutlookDicKey" :form="form"></FormItem>
              <FormItem :field="form.memberTypeKeys" :form="form"></FormItem>
            </div>
            <div class="content-main">
              <div class="content-main-header">通讯信息</div>
              <FormItem :field="form.fixedTelephone" :form="form"></FormItem>
              <FormItem :field="form.locationProvince" :form="form"></FormItem>
              <FormItem :field="form.postalAddress" :form="form"></FormItem>
              <FormItem :field="form.postalCode" :form="form"></FormItem>
            </div>
            <div class="content-main">
              <div class="content-main-header">证件信息</div>
              <FormItem :field="form.certificateTypeDicKey" :form="form"></FormItem>
              <FormItem :field="form.certificateNo" :form="form"></FormItem>
              <div class="form-item upload-item id-photo-item">
                <div class="form-item-label"><span class="required">*</span>电子证件照</div>
                <div class="upload-wrap id-photo-upload">
                  <div class="id-photo-tip">请上传清晰证件照，支持 jpg/png，最多 2 张</div>
                  <div class="id-photo-list">
                    <div
                      class="id-photo-card"
                      v-for="(item, index) in idPhotoFileList"
                      :key="item.uid || index"
                    >
                      <img :src="item.url" :alt="item.name" />
                      <div class="id-photo-mask">
                        <a :href="item.url" target="_blank" rel="noreferrer">预览</a>
                        <span @click="deleteIdPhoto(index)">删除</span>
                      </div>
                      <div class="id-photo-name" :title="item.name">{{item.name}}</div>
                    </div>
                    <label
                      class="id-photo-add"
                      :class="{ loading: loading, disabled: idPhotoFileList.length >= 2 }"
                      v-if="idPhotoFileList.length < 2"
                    >
                      <i class="add-icon"></i>
                      <span class="add-title">{{ loading ? '上传中...' : '上传证件照' }}</span>
                      <span class="add-sub">点击选择图片</span>
                      <input
                        v-if="!loading"
                        type="file"
                        accept="image/*"
                        @change="onIdPhotoChange"
                      />
                    </label>
                  </div>
                  <div class="error-tip" v-if="idPhotoError">{{idPhotoError}}</div>
                </div>
              </div>
            </div>
            <div class="content-main">
              <div class="content-main-header">教育情况</div>
              <!-- // <FormItem :field="form.professionalTitleIdentity" :form="form"></FormItem> -->
              <FormItem :field="form.highestEducationDicKey" :form="form"></FormItem>
              <FormItem :field="form.major" :form="form"></FormItem>            
            </div>
            <div class="content-main">
              <div class="content-main-header">工作信息</div>
              <FormItem :field="form.professionalTitle" :form="form"></FormItem>
              <FormItem :field="form.unitName" :form="form"></FormItem>
              <FormItem :field="form.currentPosition" :form="form"></FormItem>
              <FormItem :field="form.workExperience" :form="form"></FormItem>
            </div>
            <div class="content-main">
              <div class="content-main-header">上传资料</div>
              <div class="form-item upload-item attach-item">
                <div class="form-item-label"><span class="required">*</span>上传资料</div>
                <div class="upload-wrap attach-upload">
                  <div class="upload-add attach-upload-btn" :class="attachLoading ? 'loading' : ''">
                    上传资料
                    <input v-if="!attachLoading" type="file" @change="onAttachChange">
                  </div>
                  <div class="upload-file-wrap attach-file-wrap" v-if="attachFileList.length">
                    <div
                      class="upload-file"
                      v-for="(item, index) in attachFileList"
                      :key="item.uid || index"
                    >
                      <img src="../../assets/images/icon-file.png" alt="">
                      <span>{{item.name}}</span>
                      <i class="upload-file-delete" @click="deleteAttach(index)"></i>
                    </div>
                  </div>
                  <div class="attach-tip">
                    <p class="attach-tip-highlight">请上传相应要求的职称证书/学位证书/社保缴纳证明/其它证明材料等</p>
                    <p class="attach-tip-title">个人入会还需具备下列条件之一：</p>
                    <p>（1）取得工程师以上及相应的职称或硕士以上学位的风景园林科技工作者；</p>
                    <p>（2）高等院校本科毕业，从事风景园林工作三年以上；大专毕业，从事风景园林工作四年以上；中专毕业，从事风景园林工作五年以上的风景园林科技工作者；</p>
                    <p>（3）技师或风景园林建设事业有突出贡献的风景园林工作者；</p>
                    <p>（4）热心并积极支持本会工作，有经验、有成绩的风景园林领导干部。</p>
                    <p class="attach-tip-note">文件个数不受限制</p>
                  </div>
                  <div class="error-tip" v-if="attachError">{{attachError}}</div>
                </div>
              </div>
            </div>
          <!-- <div class="content-main">
              <div class="content-main-header">其他信息</div>
              <FormItem :field="form.personSfys" :form="form"></FormItem>
              <FormItem :field="form.personSfcjxz" :form="form"></FormItem>
              <FormItem :field="form.personSfjq" :form="form"></FormItem>
              <FormItem :field="form.personSfrddb" :form="form"></FormItem>
              <FormItem :field="form.personSfzshy" :form="form"></FormItem>
              <FormItem :field="form.personSfjr" :form="form"></FormItem>
            </div>-->
          </template>
          <div class="card-more" @click="submitForm">提交</div>
        </div>
        <div class="step-line" v-show="stepLine.length">
          <div class="step-line-wrap">
            <div class="step-line-item"
                :class="activeStepLine === index ? 'active' : ''"
                v-for="(item, index) in stepLine"
                :key="index"
                @click="setActiveStepLine(index)">
              <span>{{ item }}</span>    
            </div>
          </div>
        </div>
      </div>
      <div class="content-box result" v-if="activeStep == 3">
        <div class="result-icon">
          <svg focusable="false" class="" data-icon="check-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"></path></svg>
        </div>
        <div class="result-title">您的注册信息已成功提交，我们将于3天内尽快审批，初始登录账号为手机号，密码为123456。</div>
        <div class="card-more" @click="goBack">返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import router from '@/router';
import modal from '@/components';
import Breadcrumbs from "@/components/Breadcrumbs";
import Table from '@/components/Table';
import FormItem from "@/components/FormItem";
import upload from '@/service/upload';
import { uuid } from "@/service/util";
import { validatePhone, registerOrg, registerPersonal, getDict } from './service/api';
import ApprovalProgressQuery from './components/ApprovalProgressQuery.vue';
import { nationDict, provinceDict, personalMemberTypeOptions } from './service/dict';

const stepLineConfig = {
  person: ['账户信息', '基本信息', '通讯信息', '证件信息', '教育情况', '工作信息', '上传资料'],
  group: ['账户信息', '基本信息', '注册信息', '上传申报表']
};

/** 个人/团体共用字段 */
const COMMON_FIELD_CODES = [
  'phone',
  'email',
  'fixedTelephone',
  'locationProvince',
  'postalAddress',
  'postalCode',
];

/** 仅个人会员字段 */
const PERSON_ONLY_FIELD_CODES = [
  'realName',
  'enName',
  'sex',
  'nation',
  'politicalOutlookDicKey',
  'memberTypeKeys',
  'certificateTypeDicKey',
  'certificateNo',
  'highestEducationDicKey',
  'major',
  'professionalTitle',
  'unitName',
  'currentPosition',
  'workExperience',
];

/** 仅团体会员字段 */
const GROUP_ONLY_FIELD_CODES = [
  'adminName',
  'orgName',
  'orgTypeDicKey',
  'orgCategaryDicKey',
  'companyProfile',
  'registrationTime',
  'registeredCapital',
  'legalRepresentative',
  'socialUnifiedCreditCode',
  'scopeOfBusiness',
];

function getRegisterFieldCodes(memberCategary) {
  if (memberCategary === 'group') {
    return COMMON_FIELD_CODES.concat(GROUP_ONLY_FIELD_CODES);
  }
  if (memberCategary === 'person') {
    return COMMON_FIELD_CODES.concat(PERSON_ONLY_FIELD_CODES);
  }
  return [];
}
export default {
  data() {
    return {
      breadRoutes: [{
    		href: '/',
    		name: '首页'
    	}, {
    		name: '入会须知'
    	}],
      activeStep: 1,
      memberCategary: '',
      columns: [{
        key: 'memberType',
        dataIndex: 'memberType',
        name: '会员类型'
      }, {
        key: 'desc',
        dataIndex: 'desc',
        width: '60%',
        name: '简要说明'
      }, {
        key: 'memberCost',
        dataIndex: 'memberCost',
        name: '会费标准'
      }],
      groupData: [{
        memberType: '普通会员单位',
        desc: '普通会员单位',
        memberCost: '1年3000元'
      }, {
        memberType: '理事单位',
        desc: '理事单位',
        memberCost: '1年6000元'
      }, {
        memberType: '常务理事单位',
        desc: '常务理事单位',
        memberCost: '1年9000元'
      }],
      personalData: [{
        memberType: '个人会员',
        desc: '（一）拥护本会章程；（二）有加入本会的意愿；（三）在本会的业务领域内具有一定的影响。',
        memberCost: '250元/届（五年）'
      },
      // {
      //   memberType: '学生会员',
      //   desc: '硕士、博士研究生、大学本科三年级（含三年级）以上的学生	',
      //   memberCost: '1年20元'
      // }, {
      //   memberType: '资深会员',
      //   desc: '资深会员',
      //   memberCost: '1年50元'
      // }
      ],
      activeStepLine: 0,
      stepLine: [],
      loading: false,
      attachLoading: false,
      currentFileList: [],
      idPhotoFileList: [],
      attachFileList: [],
      idPhotoError: '',
      attachError: '',
      orgAttachError: '',
      form: {

        // 以下是个人会员和团体会员通用字段
        phone: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'phone',
          fieldName: '登录手机号',
          validate: async v => {
            if (!v) {
              this.form.phone.error = '登录手机号必填';
              return false;
            }
            try {
              // 校验phone是否重复
              const res = await validatePhone({
                phone: v
              });
              if (!res) {
                this.showRegisteredPhoneDialog();
                this.form.phone.error = '';
                return false;
              }
            } catch (ex) {
              if (ex === '该账号已注册为会员') {
                this.showRegisteredPhoneDialog();
                this.form.phone.error = '';
                return false;
              }
              this.$message({
                type: 'error',
                content: ex
              });
              this.form.phone.error = ex;
              return false;
            }
            this.form.phone.error = '';
            return true;
          }
        },
        email: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'email',
          fieldName: '电子邮箱',
          validate: (v) => {
            if (!v) {
              this.form.email.error = '电子邮箱必填';
              return false;
            }
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
              this.form.email.error = '电子邮箱格式不正确';
              return false;
            }
            this.form.email.error = '';
            return true;
          }
        },
        fixedTelephone: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'fixedTelephone',
          fieldName: '固定电话',         
        },
        locationProvince: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Select',
          fieldCode: 'locationProvince',
          fieldName: '所属地区',
          valueList: provinceDict.map(item => ({
            key: item,
            value: item
          }))      
        },
        postalAddress: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'postalAddress',
          fieldName: '通讯地址',         
        },
        postalCode: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'postalCode',
          fieldName: '邮政编码',         
        },

        // password: {
        //   require: true,
        //   error: false,
        //   value: '',
        //   fieldType: 'Input',
        //   inputType: 'password',
        //   fieldCode: 'password',
        //   fieldName: '设定密码',
        //   validate: v => {
        //     if (!v) {
        //       this.form.password.error = '设定密码必填';
        //       return false;
        //     }
        //     this.form.password.error = '';
        //     return true;
        //   }
        // },
        // repassword: {
        //   require: true,
        //   error: false,
        //   value: '',
        //   fieldType: 'Input',
        //   inputType: 'password',
        //   fieldCode: 'repassword',
        //   fieldName: '重复设定密码',
        //   validate: v => {
        //     if (!v) {
        //       this.form.repassword.error = '重复设定密码必填';
        //       return false;
        //     }
        //     if (v !== this.form.password.value) {
        //       this.form.repassword.error = '重复设定密码和密码不一致';
        //       return false;
        //     }
        //     this.form.repassword.error = '';
        //     return true;
        //   }
        // },
        // memberType: {
        //   require: true,
        //   error: false,
        //   value: '',
        //   fieldType: 'Radio',
        //   fieldCode: 'memberType',
        //   fieldName: '意向会员类型',
        //   valueList: [{
        //     key: 1,
        //     value: '社会团体单位会员'
        //   }, {
        //     key: 2,
        //     value: '企事业单位会员'
        //   }, {
        //     key: 3,
        //     value: '高等院校单位会员'
        //   }],
        //   validate: v => {
        //     if (!v) {
        //       this.form.memberType.error = '意向会员类型必填';
        //       return false;
        //     }
        //     this.form.memberType.error = '';
        //     return true;
        //   }
        // },
        // expressTime: {
        //   require: true,
        //   error: false,
        //   value: '',
        //   fieldType: 'Radio',
        //   fieldCode: 'expressTime',
        //   fieldName: '有效期限',
        //   valueList: [{
        //     key: 1,
        //     value: '注册一年'
        //   }, {
        //     key: 2,
        //     value: '注册两年'
        //   }, {
        //     key: 3,
        //     value: '注册三年'
        //   }],
        //   validate: v => {
        //     if (!v) {
        //       this.form.expressTime.error = '有效期限必填';
        //       return false;
        //     }
        //     this.form.expressTime.error = '';
        //     return true;
        //   }
        // },
        // 以下是团体会员字段
        adminName: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'adminName',
          fieldName: '联系人',
          validate: v => {
            if (!v) {
              this.form.adminName.error = '联系人必填';
              return false;
            }
            this.form.adminName.error = '';
            return true;
          }
        },
        orgName: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'orgName',
          fieldName: '单位名称',
          validate: v => {
            if (!v) {
              this.form.orgName.error = '单位名称必填';
              return false;
            }
            this.form.orgName.error = '';
            return true;
          }
        },
        orgTypeDicKey: {
          require: true,
          error: false,
          value: '',
          fieldPlaceholder: '请选择会员类型',
          fieldType: 'Select',
          fieldCode: 'orgTypeDicKey',
          fieldName: '会员类型',
          valueList: [],
          validate: v => {
            if (!v) {
              this.form.orgTypeDicKey.error = '会员类型必填';
              return false;
            }
            this.form.orgTypeDicKey.error = '';
            return true;
          }
        },        
        orgCategaryDicKey: {
          require: true,
          error: false,
          value: '',
          fieldPlaceholder: '请选择单位类别',
          fieldType: 'Select',
          fieldCode: 'orgCategaryDicKey',
          fieldName: '单位类别',
          valueList: [],
          validate: v => {
            if (!v) {
              this.form.orgCategaryDicKey.error = '单位类别必填';
              return false;
            }
            this.form.orgCategaryDicKey.error = '';
            return true;
          }
        },
        // szdq: {
        //   require: true,
        //   error: false,
        //   value: '',
        //   fieldPlaceholder: '请选择所在地区',
        //   fieldType: 'Select',
        //   fieldCode: 'szdq',
        //   fieldName: '所在地区',
        //   valueList: [{
        //     key: 1,
        //     value: '杭州'
        //   }, {
        //     key: 2,
        //     value: '金华'
        //   }, {
        //     key: 3,
        //     value: '温州'
        //   }]          
        // },
        // txdz: {
        //   require: true,
        //   error: false,
        //   value: '',
        //   fieldType: 'Input',
        //   fieldCode: 'txdz',
        //   fieldName: '通讯地址',
        //   validate: v => {
        //     if (!v) {
        //       this.form.company.error = '通讯地址必填';
        //       return false;
        //     }
        //     this.form.company.error = '';
        //     return true;
        //   }        
        // },
        // yzbm: {
        //   require: true,
        //   error: false,
        //   value: '',
        //   fieldType: 'Input',
        //   fieldCode: 'yzbm',
        //   fieldName: '邮政编码',
        //   validate: v => {
        //     if (!v) {
        //       this.form.company.error = '邮政编码必填';
        //       return false;
        //     }
        //     this.form.company.error = '';
        //     return true;
        //   }        
        // },
        companyProfile: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Text',
          fieldCode: 'companyProfile',
          fieldName: '单位简介',
        },
        // xm: {
        //   require: false,
        //   error: false,
        //   value: '',
        //   fieldType: 'Input',
        //   fieldCode: 'xm',
        //   fieldName: '姓名',        
        // },        
        // xb: {
        //   require: true,
        //   error: false,
        //   value: '',
        //   fieldType: 'Radio',
        //   fieldCode: 'xb',
        //   fieldName: '性别',
        //   valueList: [{
        //     key: 1,
        //     value: '男'
        //   }, {
        //     key: 2,
        //     value: '女'
        //   }],          
        // },
        // zw: {
        //   require: false,
        //   error: false,
        //   value: '',
        //   fieldType: 'Input',
        //   fieldCode: 'zw',
        //   fieldName: '职务',        
        // },
        // gddh: {
        //   require: false,
        //   error: false,
        //   value: '',
        //   fieldType: 'Input',
        //   fieldCode: 'gddh',
        //   fieldName: '固定电话',        
        // },
        // sj: {
        //   require: false,
        //   error: false,
        //   value: '',
        //   fieldType: 'Input',
        //   fieldCode: 'sj',
        //   fieldName: '手机',        
        // },
        // dzyx: {
        //   require: false,
        //   error: false,
        //   value: '',
        //   fieldType: 'Input',
        //   fieldCode: 'dzyx',
        //   fieldName: '电子邮箱',        
        // },
        registrationTime: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Date',
          fieldCode: 'registrationTime',
          fieldName: '成立时间',        
        },
        registeredCapital: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'registeredCapital',
          fieldName: '注册资金',        
        },
        legalRepresentative: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'legalRepresentative',
          fieldName: '法定代表人',        
        },
        socialUnifiedCreditCode: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'socialUnifiedCreditCode',
          fieldName: '社会统一信用代码',   
          validate: v => {
            if (!v) {
              this.form.socialUnifiedCreditCode.error = '社会统一信用代码必填';
              return false;
            }
            this.form.socialUnifiedCreditCode.error = '';
            return true;
          }     
        },
        scopeOfBusiness: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'scopeOfBusiness',
          fieldName: '业务范围',        
        },



        // 以下是个人会员字段
        realName: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'realName',
          fieldName: '真实姓名', 
          validate: v => {
            if (!v) {
              this.form.realName.error = '真实姓名必填';
              return false;
            }
            this.form.realName.error = '';
            return true;
          }       
        },
        enName: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'enName',
          fieldName: '英文姓名',        
        },
        sex: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Radio',
          fieldCode: 'sex',
          fieldName: '性别',
          valueList: [{
            key: 'M',
            value: '男'
          }, {
            key: 'F',
            value: '女'
          }],
          validate: v => {
            if (!v) {
              this.form.sex.error = '请选择性别';
              return false;
            }
            this.form.sex.error = '';
            return true;
          }       
        },
        nation: {
          require: false,
          error: false,
          value: '',
          fieldPlaceholder: '请选择民族',
          fieldType: 'Select',
          fieldCode: 'nation',
          fieldName: '民族',
          valueList: nationDict.map(item => ({
            key: item,
            value: item
          })),                   
        },
        politicalOutlookDicKey: {
          require: false,
          error: false,
          value: '',
          fieldPlaceholder: '请选择政治面貌',
          fieldType: 'Select',
          fieldCode: 'politicalOutlookDicKey',
          fieldName: '政治面貌',
          valueList: []  
        },
        memberTypeKeys: {
          require: true,
          error: false,
          value: '',
          fieldPlaceholder: '请选择分支机构',
          fieldType: 'Select',
          fieldCode: 'memberTypeKeys',
          fieldName: '分支机构',
          valueList: personalMemberTypeOptions,
          validate: v => {
            if (!v) {
              this.form.memberTypeKeys.error = '请选择分支机构';
              return false;
            }
            this.form.memberTypeKeys.error = '';
            return true;
          }
        },
        certificateTypeDicKey: {         
          require: true,
          error: false,
          value: '',
          fieldPlaceholder: '请选择证件类型',
          fieldType: 'Select',
          fieldCode: 'certificateTypeDicKey',
          fieldName: '证件类型',
          valueList: [],
          validate: v => {
            if (!v) {
              this.form.certificateTypeDicKey.error = '请选择证件类型';
              return false;
            }
            this.form.certificateTypeDicKey.error = '';
            return true;
          }
        },
        certificateNo: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'certificateNo',
          fieldName: '证件编号',  
          validate: v => {
            if (!v) {
              this.form.certificateNo.error = '证件编号必填';
              return false;
            }
            this.form.certificateNo.error = '';
            return true;
          }       
        },       
        // professionalTitleIdentity: {
        //   require: true,
        //   error: false,
        //   value: '',
        //   fieldPlaceholder: '请选择职称/身份',
        //   fieldType: 'Select',
        //   fieldCode: 'professionalTitleIdentity',
        //   fieldName: '职称/身份',
        //   valueList: [{
        //     key: 1,
        //     value: '高级教师'
        //   }, {
        //     key: 2,
        //     value: '中级教师'
        //   }]          
        // },
        highestEducationDicKey: {
          require: false,
          error: false,
          value: '',
          fieldPlaceholder: '请选择最高学历',
          fieldType: 'Select',
          fieldCode: 'highestEducationDicKey',
          fieldName: '最高学历',
          valueList: []  
        },       
        major: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'major',
          fieldName: '所学专业',        
        },
        professionalTitle: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'professionalTitle',
          fieldName: '职称',
          fieldPlaceholder: '请输入职称',
        },
        unitName: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'unitName',
          fieldName: '单位名称',
          fieldPlaceholder: '请输入单位名称',
        },
        currentPosition: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'currentPosition',
          fieldName: '现任职务',
          fieldPlaceholder: '请输入现任职务',
        },
        workExperience: {
          require: false,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'workExperience',
          fieldName: '工作经历',
          fieldPlaceholder: '请输入工作经历',
        },
        // personSfys: {       
        //   require: false,
        //   error: false,
        //   value: '',
        //   fieldPlaceholder: '请选择是否院士',
        //   fieldType: 'Select',
        //   fieldCode: 'personSfys',
        //   fieldName: '是否院士',
        //   valueList: [{
        //     key: 1,
        //     value: '是'
        //   }, {
        //     key: 2,
        //     value: '否'
        //   }]       
        // },
        // personSfcjxz: {         
        //   require: false,
        //   error: false,
        //   value: '',
        //   fieldPlaceholder: '请选择是否长江学者',
        //   fieldType: 'Select',
        //   fieldCode: 'personSfcjxz',
        //   fieldName: '是否长江学者',
        //   valueList: [{
        //     key: 1,
        //     value: '是'
        //   }, {
        //     key: 2,
        //     value: '否'
        //   }]       
        // },
        // personSfjq: {         
        //   require: false,
        //   error: false,
        //   value: '',
        //   fieldPlaceholder: '请选择是否杰青',
        //   fieldType: 'Select',
        //   fieldCode: 'personSfjq',
        //   fieldName: '是否杰青',
        //   valueList: [{
        //     key: 1,
        //     value: '是'
        //   }, {
        //     key: 2,
        //     value: '否'
        //   }]       
        // },
        // personSfrddb: {          
        //   require: false,
        //   error: false,
        //   value: '',
        //   fieldPlaceholder: '请选择是否人大代表',
        //   fieldType: 'Select',
        //   fieldCode: 'personSfrddb',
        //   fieldName: '是否人大代表',
        //   valueList: [{
        //     key: 1,
        //     value: '是'
        //   }, {
        //     key: 2,
        //     value: '否'
        //   }]        
        // },
        // personSfzshy: {          
        //   require: false,
        //   error: false,
        //   value: '',
        //   fieldPlaceholder: '请选择是否终身会员',
        //   fieldType: 'Select',
        //   fieldCode: 'personSfzshy',
        //   fieldName: '是否终身会员',
        //   valueList: [{
        //     key: 1,
        //     value: '是'
        //   }, {
        //     key: 2,
        //     value: '否'
        //   }]        
        // },
        // personSfjr: {          
        //   require: false,
        //   error: false,
        //   value: '',
        //   fieldPlaceholder: '请选择是否军人',
        //   fieldType: 'Select',
        //   fieldCode: 'personSfjr',
        //   fieldName: '是否军人',
        //   valueList: [{
        //     key: 1,
        //     value: '是'
        //   }, {
        //     key: 2,
        //     value: '否'
        //   }]       
        // },         
      }
    }
  },
  computed: {
    ...mapState(['user'])
  },
  components: {
    Breadcrumbs,
    Table,
    FormItem,
    ApprovalProgressQuery,
  },
  mounted() {
    getDict().then(res => {
      // 会员类型  mem_org_type
      // 单位类别  org_categary
      // 政治面貌  mem_personal_political_status
      // 证件类型  certificate_type
      // 最高学历  mem_personal_highest_education
      this.form.orgTypeDicKey.valueList = (res.mem_org_type || []).map(item => {
        return {
          key: item.dicKey,
          value: item.dicValue
        }
      });
      this.form.orgCategaryDicKey.valueList = (res.org_categary || []).map(item => {
        return {
          key: item.dicKey,
          value: item.dicValue
        }
      });
      this.form.politicalOutlookDicKey.valueList = (res.mem_personal_political_status || []).map(item => {
        return {
          key: item.dicKey,
          value: item.dicValue
        }
      });
      this.form.certificateTypeDicKey.valueList = (res.certificate_type || []).map(item => {
        return {
          key: item.dicKey,
          value: item.dicValue
        }
      });
      this.form.highestEducationDicKey.valueList = (res.mem_personal_highest_education || []).map(item => {
        return {
          key: item.dicKey,
          value: item.dicValue
        }
      });
    })
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.getScrollId);
  },
  watch: {
    $route(v) {
      if (v.name === 'MemberRegister') {
        window.removeEventListener('scroll', this.getScrollId);
        this.init();
      }
    },
  },
  methods: {
    init() {
      this.activeStep = 1;
      // 区分个人还是团体 person group   
      this.memberCategary = router.currentRoute.params.id;
      this.stepLine = stepLineConfig[this.memberCategary] || [];
    },
    showRegisteredPhoneDialog() {
      modal.confirm({
        title: '该手机号已注册',
        content: '您已是学会会员，可直接登录。初始登录账号为手机号，密码为 123456。',
        confirm: () => {
          router.push('/login');
        },
      });
    },
    validInfo(step) {
      if (step === 2) {
        if (this.user && ['org', 'personal'].indexOf(this.user.memType) !== -1) {
          modal.confirm({
            title: '您已经是会员，不需要再次注册',
            hideCancel: true,
            confirm:() => {},
          });
          return false;
        }
      }
      return true;
    },
    setFormValue() {
      this.form.phone.value = this.user.phone || '';
      this.form.email.value = this.user.mailbox || '';
    },
    onFileChange($event) {
			const file = $event.target.files[0];
			if (this.loading) return false;
			this.loading = true;
			upload(file).then(url => {
				this.currentFileList = [{
          fileBizType: "cover",
          type: "image/png",
          uid: uuid(),
					name: file.name,
					url
				}]
        this.orgAttachError = '';
			}).finally(() => {
				this.loading = false;
			})
		},  
    deleteFile(idx) {
			this.currentFileList.splice(idx, 1);
		},
    onIdPhotoChange($event) {
      const file = $event.target.files[0];
      if (!file || this.loading) return false;
      if (this.idPhotoFileList.length >= 2) {
        this.idPhotoError = '最多上传2张证件照';
        $event.target.value = '';
        return false;
      }
      this.loading = true;
      upload(file).then(url => {
        this.idPhotoFileList.push({
          fileBizType: 'cover',
          type: file.type || 'image/png',
          uid: uuid(),
          name: file.name,
          url
        });
        this.idPhotoError = '';
      }).finally(() => {
        this.loading = false;
        $event.target.value = '';
      });
    },
    deleteIdPhoto(idx) {
      this.idPhotoFileList.splice(idx, 1);
    },
    onAttachChange($event) {
      const file = $event.target.files[0];
      if (!file || this.attachLoading) return false;
      this.attachLoading = true;
      upload(file).then(url => {
        this.attachFileList.push({
          fileBizType: 'attachment',
          type: file.type || 'application/octet-stream',
          uid: uuid(),
          name: file.name,
          url
        });
        this.attachError = '';
      }).finally(() => {
        this.attachLoading = false;
        $event.target.value = '';
      });
    },
    deleteAttach(idx) {
      this.attachFileList.splice(idx, 1);
    },
    changeStep(step) {
      const isCanChangeStep = this.validInfo(step);
      if (!isCanChangeStep) {
        return false;
      }
      if (step === 2 && this.user) {
        this.setFormValue();
      }
      this.activeStep = step;
      this.$nextTick(() => {
        if (step === 2) {
          window.addEventListener('scroll', this.getScrollId);
        } else {
          window.removeEventListener('scroll', this.getScrollId);
        }
      })
    },
    getScrollId() {
      const headerDoms = this.$refs.wrap.querySelectorAll('.content-main-header');
      let activeIndex = 0;
      for (let i = 0; i < headerDoms.length; i++) {
        const position = headerDoms[i].getBoundingClientRect();
        if (position.top >= 0 && position.top <= 400) {
          activeIndex = i;
          break;
        }
      }
      this.activeStepLine = activeIndex;
    },
    setActiveStepLine(index) {
      this.activeStepLine = index;
      const targetDom =  this.$refs.wrap.querySelectorAll('.content-main-header')[index];
      window.scrollTo({top: targetDom.getBoundingClientRect().top - 238, behavior: 'smooth'})
    },
    scrollToFirstError() {
      this.$nextTick(() => {
        const wrap = this.$refs.wrap;
        if (!wrap) {
          return;
        }
        const errorBlocks = [
          ...wrap.querySelectorAll('.form-item-value.error'),
          ...wrap.querySelectorAll('.upload-item .error-tip'),
        ].filter((el) => {
          const text = (el.textContent || '').trim();
          return text && el.getBoundingClientRect().height > 0;
        });
        if (!errorBlocks.length) {
          return;
        }
        errorBlocks.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
        const target = errorBlocks[0].closest('.form-item')
          || errorBlocks[0].closest('.content-main')
          || errorBlocks[0];
        const offsetTop = window.pageYOffset + target.getBoundingClientRect().top - 180;
        window.scrollTo({
          top: Math.max(offsetTop, 0),
          behavior: 'smooth',
        });
        const headers = wrap.querySelectorAll('.content-main-header');
        for (let i = 0; i < headers.length; i++) {
          const section = headers[i].closest('.content-main');
          if (section && section.contains(target)) {
            this.activeStepLine = i;
            break;
          }
        }
      });
    },
    showSubmitError(message) {
      this.$message({
        type: 'error',
        content: message,
      });
      this.scrollToFirstError();
    },
    /** 当前注册类型需要校验/提交的字段 */
    getActiveFieldCodes() {
      return getRegisterFieldCodes(this.memberCategary);
    },
    /** 按字段列表组装提交参数 */
    buildParamsByFieldCodes(fieldCodes) {
      const params = {};
      fieldCodes.forEach((code) => {
        const field = this.form[code];
        if (field && Object.prototype.hasOwnProperty.call(field, 'value')) {
          params[code] = field.value;
        }
      });
      return params;
    },
    /** 仅校验当前会员类型对应字段，互不串扰 */
    async validateForm() {
      const fieldCodes = this.getActiveFieldCodes();
      if (!fieldCodes.length) {
        this.showSubmitError('注册类型不正确');
        return false;
      }
      let firstErrorMessage = '';
      for (let i = 0; i < fieldCodes.length; i += 1) {
        const field = this.form[fieldCodes[i]];
        if (!field || typeof field.validate !== 'function') {
          continue;
        }
        const validRes = await field.validate(field.value);
        if (!validRes && !firstErrorMessage) {
          firstErrorMessage = field.error || `请完善${field.fieldName || '表单'}信息`;
        }
      }
      if (firstErrorMessage) {
        this.showSubmitError(firstErrorMessage);
        return false;
      }
      return true;
    },
    /** 校验当前类型的附件 */
    validateAttachments() {
      if (this.memberCategary === 'person') {
        if (!this.idPhotoFileList.length) {
          this.idPhotoError = '请上传电子证件照';
          this.showSubmitError('请上传电子证件照');
          return false;
        }
        this.idPhotoError = '';
        if (!this.attachFileList.length) {
          this.attachError = '请上传资料';
          this.showSubmitError('请上传资料');
          return false;
        }
        this.attachError = '';
        return true;
      }
      if (this.memberCategary === 'group') {
        if (!this.currentFileList.length) {
          this.orgAttachError = '请上传已盖章的团体会员申报表';
          this.showSubmitError('请上传已盖章的团体会员申报表');
          return false;
        }
        this.orgAttachError = '';
        return true;
      }
      return false;
    },
    async submitForm() {
      const validForm = await this.validateForm();
      if (!validForm) {
        return false;
      }
      if (!this.validateAttachments()) {
        return false;
      }

      const fieldCodes = this.getActiveFieldCodes();
      const params = this.buildParamsByFieldCodes(fieldCodes);
      if (this.user) {
        params.portalUserId = this.user.id;
      }

      let apiFunc = null;
      if (this.memberCategary === 'person') {
        params.memberTypeKeys = params.memberTypeKeys || '';
        params.idPhotoFileList = this.idPhotoFileList;
        params.applyFileList = this.attachFileList;
        apiFunc = registerPersonal;
      } else if (this.memberCategary === 'group') {
        params.applyFileList = this.currentFileList;
        apiFunc = registerOrg;
      } else {
        this.showSubmitError('注册类型不正确');
        return false;
      }

      apiFunc(params).then(() => {
        this.changeStep(3);
      }).catch(error => {
        this.$message({
          type: 'error',
          content: error
        })
      });
    },
    goBack() {
      router.replace(`/`);
    },
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';
.member-sign {
  background: url(../../assets/images/member-sign-bg.png) no-repeat center 0;
  background-size: 100% 100%;
}
.block-wrap {
  background: url('http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/active-detail-bg.jpg') no-repeat center 0;
  background-size: 100% 330px;
  min-height: 100vh;
  padding-top: 12px;
}
.approval-query-wrap {
  padding: 0 43px;
  margin-bottom: 20px;
}
.content-box {
  width: 100px;
  box-sizing: border-box;
  padding: 59px 43px;
  background: #fff;

  &.flex {
    display: flex;
  }

  .form-content {
    flex: 3;
  }

  .step-line {
    flex: 1;
    padding-left: 100px;

    &-wrap {
      position: sticky;
      left: 0;
      top: 0;
      padding-bottom: 140px;
      
      &::before {
        content: '';
        position: absolute;
        left: 8px;
        top: 10px;
        z-index: -1;
        width: 4px;
        height: 100%;
        background: #F1F3F3;
        border-radius: 2px;
      }
    }

    &-item {
      padding-left: 26px;
      background: url(../../assets/images/icon-dot.png) no-repeat 0 center;
      background-size: 20px 20px;
      margin-bottom: 36px;
      cursor: pointer;

      &.active {
        background-image: url(../../assets/images/icon-dot-active.png);

        > span {
          background: url(../../assets/images/icon-step-active.png) no-repeat 0 0;
          background-size: 100% 100%;
          color: #06AE63;
        }
      }

      > span {
        display: block;
        padding-left: 13px;
        width: 112px;
        height: 33px;
        line-height: 33px;
        font-size: 16px;
        font-family: PingFang SC;
        color: #787878;
      }
    }
  }

  .content-title {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #131415;
    text-align: center;
    margin-bottom: 60px;
  }

  .content-main {
    margin-bottom: 57px;
    &-header {
      height: 40px;
      line-height: 40px;
      background: url(../../assets/images/active-sign-header-bg.png) no-repeat center 0;
      background-size: 100% 100%;
      padding-left: 60px;
      margin-bottom: 30px;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #131415;
      display:flex;
    }

    .list-wrap {
      .list-item {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #131415;
        line-height: 40px;
      }
      .list-item-subtitle {
        margin-top: 12px;
        font-weight: 600;
      }
    }
  }

  .card-more {
    margin: 0 auto;
    width: 240px;
    height: 60px;
    background: #06AE63;
    color: #fff;
    line-height: 60px;
  }
}

.result {
  &-icon {
    margin-bottom: 24px;
    text-align: center;
    font-size: 72px;
    color: #52c41a;
    font-style: normal;
    line-height: 0;
    text-align: center;
    text-transform: none;
    vertical-align: -0.125em;
    text-rendering: optimizelegibility;
    -webkit-font-smoothing: antialiased;
  }

  &-title {
    color: #000000;
    font-size: 18px;
    line-height: 1.8;
    text-align: center;
    margin-bottom: 24px;
  }

  &-content {
    width: 600px;
    padding: 20px 100px;
    background: #F9F9F9;
    margin: 0 auto 24px;

    .form-item-value {
      border-bottom: none;
      height: unset;
    }
  }
}
.download-wrap {
  background: #F6F6F6;
  border: 1px solid #EAEAEA;
  padding: 35px 20px 0 24px;
  background-color: #fafafa;
}
.download-item {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  
  .download-file-icon {
    height: 24px;
    margin-right: 12px;
  }

  .download-title {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #06AE63;
    width:85%;
  }

  .download-op {
    margin-left: auto;
    padding-left: 28px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #131415;
    background: url(../../assets/images/icon-download.png) no-repeat 0 center;
    background-size: 24px 24px;
  }  
}
.help-tip-c{
    font-size:15px;
    color:#9d9e9e;
    margin-top:5px;
    margin-left:5px;
  }
.form-item {
  padding: 0 40px 0 56px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;

  &.upload-item {
    align-items: flex-start;
  }
  &-label {
    width: 80px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    margin-right: 20px;
  }
  .upload-wrap {
    .error-tip {
      font-size: 12px;
      color: #FF3B2F;
      line-height: 20px;
    }

    .upload-file-wrap {
      display: flex;
      flex-wrap: wrap;
      padding-top: 20px;
      
      .upload-file {
        padding: 10px;
        color: #06AE63;
        border-radius: 5px;
        margin-right: 20px;
        margin-bottom: 10px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        > img {
          width: 50px;
          height: 50px;
          display: block;
          margin-bottom: 5px;
        }

        span {
          width: 250px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        
        &:hover {
          .upload-file-delete {
            display: block;
          }
        }
        
        &-delete {
          display: none;
          cursor: pointer;
          width: 15px;
          height: 15px;
          position: absolute;
          right: -4px;
          top: -4px;
          background: #FF3B2F url(../../assets/images/icon-close.png) no-repeat center center;
          background-size: 6px 6px;
          border-radius: 50%;
        }
      }
    }

    .upload-add {
      padding: 10px;
      color: #ffffff;
      border-radius: 5px;
      width: 120px;
      padding-left: 30px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      background: #06AE63 url(../../assets/images/icon-upload.png) no-repeat 5px center;
      background-size: 20px 20px;
      position: relative;
      
      &.loading {
        background-image: url(../../assets/images/icon-loading.gif);
        background-position: center center;
      }
      
      > input {
        position: absolute;
        cursor: pointer;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }

  &.id-photo-item {
    .form-item-label {
      width: 110px;
      line-height: 22px;
      padding-top: 8px;

      .required {
        color: #ff3b2f;
        margin-right: 2px;
      }
    }
  }

  &.attach-item {
    .form-item-label {
      width: 110px;
      line-height: 22px;
      padding-top: 8px;

      .required {
        color: #ff3b2f;
        margin-right: 2px;
      }
    }
  }
}

.attach-upload {
  flex: 1;
  min-width: 0;

  .attach-upload-btn {
    margin-bottom: 0;
  }

  .attach-file-wrap {
    padding-top: 16px;
  }

  .attach-tip {
    margin-top: 16px;
    padding: 14px 16px;
    border-radius: 8px;
    background: #fafbfc;
    border: 1px solid #eef0f2;
    font-size: 12px;
    color: #8c8c8c;
    line-height: 1.75;

    p {
      margin: 0 0 6px;
    }

    &-highlight {
      margin-bottom: 10px !important;
      font-size: 13px;
      color: #595959;
      line-height: 1.6;
    }

    &-title {
      margin-bottom: 8px !important;
      color: #595959;
      font-weight: 500;
    }

    &-note {
      margin-top: 10px !important;
      margin-bottom: 0 !important;
      color: #06ae63;
    }
  }

  .error-tip {
    margin-top: 10px;
  }
}

.id-photo-upload {
  flex: 1;
  min-width: 0;

  .id-photo-tip {
    font-size: 13px;
    color: #8c8c8c;
    line-height: 20px;
    margin-bottom: 12px;
  }

  .id-photo-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  .id-photo-card {
    position: relative;
    width: 120px;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #e8e8e8;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    > img {
      display: block;
      width: 120px;
      height: 120px;
      object-fit: cover;
      background: #f5f5f5;
    }

    .id-photo-mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 120px;
      height: 120px;
      background: rgba(0, 0, 0, 0.45);
      display: none;
      align-items: center;
      justify-content: center;
      gap: 12px;

      a,
      span {
        color: #fff;
        font-size: 13px;
        cursor: pointer;
        text-decoration: none;
        padding: 4px 8px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.16);

        &:hover {
          background: rgba(6, 174, 99, 0.9);
        }
      }
    }

    .id-photo-name {
      padding: 6px 8px;
      font-size: 12px;
      color: #595959;
      line-height: 18px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &:hover .id-photo-mask {
      display: flex;
    }
  }

  .id-photo-add {
    position: relative;
    width: 120px;
    height: 120px;
    box-sizing: border-box;
    border: 1px dashed #91d5b0;
    border-radius: 8px;
    background: linear-gradient(180deg, #f6fffb 0%, #f0faf4 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
    margin: 0;

    &:hover {
      border-color: #06ae63;
      box-shadow: 0 4px 12px rgba(6, 174, 99, 0.12);
      transform: translateY(-1px);
    }

    &.loading {
      pointer-events: none;
      opacity: 0.75;
      background: #f6fffb url(../../assets/images/icon-loading.gif) no-repeat center 36px;
      background-size: 24px 24px;

      .add-icon {
        opacity: 0;
      }
    }

    .add-icon {
      width: 32px;
      height: 32px;
      margin-bottom: 10px;
      border-radius: 50%;
      background: rgba(6, 174, 99, 0.12);
      position: relative;

      &::before,
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        background: #06ae63;
        border-radius: 1px;
        transform: translate(-50%, -50%);
      }

      &::before {
        width: 14px;
        height: 2px;
      }

      &::after {
        width: 2px;
        height: 14px;
      }
    }

    .add-title {
      font-size: 14px;
      color: #06ae63;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 20px;
      white-space: nowrap;
    }

    .add-sub {
      margin-top: 4px;
      font-size: 12px;
      color: #8c8c8c;
      line-height: 18px;
      white-space: nowrap;
    }

    > input {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
  }

  .error-tip {
    margin-top: 8px;
  }
}
</style>